export const queriesConst = {
  q: 'q',
  city: 'city',
  county: 'county',
  country: 'country',
  company: 'company',
  page: 'page'
}